<template>
	<v-card>
		<v-footer class="font-weight-thin" style="margin-left: 50px">
			<v-container>
				<v-row>
					<v-col cols="12" sm="3">
						<h5 class="mw-h3 text-green">Site Map</h5>
						<ul class="small-caps">
							<li>
								<a
									class="styleless"
									:href="view == 'visitor' ? 'https://m.works' : '/'"
									>Home</a
								>
							</li>
							<li>
								<a
									class="styleless"
									v-if="view !== 'visitor'"
									href="https://m.works"
									>About</a
								>
							</li>
							<li><a class="styleless" href="/contact">Contact</a></li>
							<li>
								<a class="styleless" href="/policies-and-notices"
									>Policies and Notices</a
								>
							</li>
						</ul>
					</v-col>
					<v-col cols="12" sm="3">
						<h5 class="mw-h3 text-green">Collaborate</h5>
						<ul class="small-caps">
							<li><a class="styleless" href="/client">Client</a></li>
							<li>
								<a class="styleless" href="/participant">Participant</a>
							</li>
						</ul>
					</v-col>
					<v-col cols="12" sm="3">
						<h5 class="mw-h3 text-green">Meister.works ltd</h5>
						<span class="small-caps">18 St. Cross Street<br/>London<br />
							EC1N 8UN</span
						>
					</v-col>
					<v-col cols="12" sm="3">
						<v-img
							src="../../assets/img/credentials1.png"
							width="100px"
						></v-img>
					</v-col>
				</v-row>
			</v-container>
		</v-footer>
	</v-card>
</template>

<script>
import Vuex from "vuex";
export default {
	name: "Footer",
	computed: {
		...Vuex.mapState({
			view: (state) => state.auth.view,
		}),
	},
};
</script>
